import { useMemo } from 'react';

import { getJobsBusinessUnitUrlPath } from '~/config';
import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { buildGetPageHref } from '~/utils/href';

export const useHref = () => {
  const { businessUnit } = useBusinessUnitContext();

  return useMemo(() => {
    const baseHref = getJobsBusinessUnitUrlPath(businessUnit);
    return {
      baseHref,
      getPageHref: buildGetPageHref({ baseHref, businessUnit }),
    };
  }, [businessUnit]);
};
